/**************************************************************************************
 *  Objetivo: Titulo Sobre
 *  Autor: Luiz Gustavo
 *  Data: 12/01/2023
 *  Versão: 1.0
 **************************************************************************************/

const TituloSobre = ({ titulo }) => {
    return (
        <div className="titulo-sobre">
            <div className="box"></div>
            <h2 className="titulo-inicio">{titulo}</h2>
        </div>
    )
}

export default TituloSobre;
